import { atom, selectorFamily } from 'recoil';
import { AgreementsService } from 'api';
import isAgreementApproved from 'utils/agreements/isAgreementApproved';
export const getActiveAgreementByIdRequestIdState = atom({
  key: 'getActiveAgreementByIdRequestIdState',
  default: 0
});
export const getActiveAgreementsForCustomer = selectorFamily({
  key: 'getActiveAgreementsForCustomer',
  get: customerId => async ({
    get
  }) => {
    if (!customerId) return {};
    get(getActiveAgreementByIdRequestIdState);
    const body = {};
    try {
      const agreements = await AgreementsService.getAgreementsForCustomer({
        customerId,
        body
      });
      const activeAgreements = agreements?.results?.filter(agreement => isAgreementApproved(agreement));
      return {
        results: activeAgreements,
        totalActiveResults: activeAgreements?.length,
        totalResults: agreements?.totalResults
      };
    } catch (e) {
      console.error(e);
    }
    return {};
  }
});